module.exports = __webpack_public_path__ + "static/img/7.b264045.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/carruselFuturo/7.jpg
// module id = AmgK
// module chunks = 5